import styled, {css} from 'styled-components'
import {MenuItem} from '@components/ui/menu-atoms/MenuAtoms.tsx'

export const StyledSelectMenuItem = styled(MenuItem)(
    ({theme: {palette}}) => css`
        justify-content: space-between;
        & > span {
            color: ${palette.neutral['500']};
        }
    `
)
